// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__228hH","row":"ProcedureTreatmentSummary_row__1KPr1"};